import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    CirclesWrapper,
    Circle,
    CirclesWrapperWhenNoArrow,
    WarningTriangleIconWrapper,
    CheckIconWrapper,
} from './BreadcrumbsCircles.style';
import { SignUpState } from 'src/domains/players/webview/components/SignUp/signupPrimary/signupState/SignUp.state';
import { StepsForCirclesType } from 'src/domains/players/webview/components/SignUp/signupPrimary/signupState/stepsStructure/SignupMainSteps';

const stepsAndCirclesFlow: Map<StepsForCirclesType, number | null> = new Map([
    ['create-account', 1],
    //['profile-verification', 2],
    ['responsible-gambling', 2],
    ['deposit', 3],
]);

const renderSteps = (state: SignUpState): Array<JSX.Element> => {
    const stepsAndCircles = stepsAndCirclesFlow;

    const out = [];
    const currentCircle = stepsAndCircles.get(state.currentView.step.type) ?? null;

    for (const stepName of new Set(stepsAndCircles.keys())) {
        const circle = stepsAndCircles.get(stepName);
        if (circle === null || circle === undefined || currentCircle === null) continue;
        const stepWithError = state.currentView.stepsWithError.includes(stepName);
        out.push(
            <Circle
                key={`step-${circle}`}
                isActive={currentCircle >= circle}
                data-test={`breadcrumbs-circle-${circle}`}
            >
                {stepWithError ? (
                    <WarningTriangleIconWrapper />
                ) : currentCircle <= circle ? (
                    circle
                ) : (
                    <CheckIconWrapper dataTest='breadcrumbs-circle-check-icon' />
                )}
            </Circle>
        );
    }

    return out;
};

interface PropsType {
    signUpState: SignUpState;
}

export const BreadcrumbsCircles = observer('BreadcrumbsCircles', (props: PropsType): JSX.Element => {
    const { signUpState } = props;
    const step = signUpState.currentView.step.type;

    const circles = (): JSX.Element => {
        if (step === 'responsible-gambling' || step === 'deposit') {
            return <CirclesWrapperWhenNoArrow>{renderSteps(signUpState)}</CirclesWrapperWhenNoArrow>;
        }
        return <CirclesWrapper>{renderSteps(signUpState)}</CirclesWrapper>;
    };

    return circles();
});
